export interface SettingsOption {
  value: string
  label: string
}

export const CURRENCY_OPTIONS: SettingsOption[] = [
  { value: 'USD', label: 'USD - US Dollar' },
  { value: 'EUR', label: 'EUR - Euro' },
  { value: 'GBP', label: 'GBP - British Pound' },
  { value: 'PKR', label: 'PKR - Pakistani Rupee' },
  { value: 'INR', label: 'INR - Indian Rupee' },
  { value: 'AED', label: 'AED - UAE Dirham' },
  { value: 'SAR', label: 'SAR - Saudi Riyal' },
  { value: 'CAD', label: 'CAD - Canadian Dollar' },
  { value: 'AUD', label: 'AUD - Australian Dollar' },
  { value: 'CHF', label: 'CHF - Swiss Franc' },
  { value: 'CNY', label: 'CNY - Chinese Yuan' },
  { value: 'JPY', label: 'JPY - Japanese Yen' },
  { value: 'KWD', label: 'KWD - Kuwaiti Dinar' },
  { value: 'BHD', label: 'BHD - Bahraini Dinar' },
  { value: 'OMR', label: 'OMR - Omani Rial' },
  { value: 'QAR', label: 'QAR - Qatari Riyal' },
  { value: 'EGP', label: 'EGP - Egyptian Pound' },
  { value: 'TRY', label: 'TRY - Turkish Lira' },
  { value: 'MYR', label: 'MYR - Malaysian Ringgit' },
  { value: 'SGD', label: 'SGD - Singapore Dollar' },
]

export const DATE_FORMAT_OPTIONS: SettingsOption[] = [
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (ISO)' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
  { value: 'DD.MM.YYYY', label: 'DD.MM.YYYY' },
]

export const WEEKDAY_OPTIONS: SettingsOption[] = [
  { value: 'Monday', label: 'Monday' },
  { value: 'Tuesday', label: 'Tuesday' },
  { value: 'Wednesday', label: 'Wednesday' },
  { value: 'Thursday', label: 'Thursday' },
  { value: 'Friday', label: 'Friday' },
  { value: 'Saturday', label: 'Saturday' },
  { value: 'Sunday', label: 'Sunday' },
]

export const PAYROLL_CYCLE_OPTIONS: SettingsOption[] = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'biweekly', label: 'Biweekly' },
  { value: 'weekly', label: 'Weekly' },
]

export const SCREENSHOT_MODE_OPTIONS: SettingsOption[] = [
  { value: 'random', label: 'Random' },
  { value: 'fixed', label: 'Fixed' },
]

const FALLBACK_TIMEZONES = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
]

function getTimezoneList(): string[] {
  if (typeof Intl !== 'undefined' && 'supportedValuesOf' in Intl) {
    try {
      return (Intl as { supportedValuesOf(key: string): string[] }).supportedValuesOf('timeZone')
    } catch {
      return FALLBACK_TIMEZONES
    }
  }
  return FALLBACK_TIMEZONES
}

let cachedTimezoneList: string[] | null = null

export function getTimezones(): string[] {
  if (cachedTimezoneList === null) {
    cachedTimezoneList = getTimezoneList()
  }
  return cachedTimezoneList
}

const MAX_TIMEZONE_RESULTS = 100

export function filterTimezoneOptions(query: string): SettingsOption[] {
  const list = getTimezones()
  const q = query.trim().toLowerCase()
  const filtered = q
    ? list.filter((tz) => tz.toLowerCase().includes(q)).slice(0, MAX_TIMEZONE_RESULTS)
    : list.slice(0, MAX_TIMEZONE_RESULTS)
  return filtered.map((value) => ({ value, label: value }))
}
